import { render, staticRenderFns } from "./webpage.vue?vue&type=template&id=4e619f78&scoped=true"
import script from "./webpage.vue?vue&type=script&lang=js"
export * from "./webpage.vue?vue&type=script&lang=js"
import style0 from "./webpage.vue?vue&type=style&index=0&id=4e619f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e619f78",
  null
  
)

export default component.exports